import React from 'react';
import LandingPage from '../Landing';

class LandingPage2 extends React.Component {

  render() {
    const headerPosStyle = {
      position: 'relative',
      top: '50%'
    };

    const h2Style = { 
      display: "inline-block",
      color: "#E1E1E1",
      backgroundColor: "#252525",
      fontSize: "35px",
      margin: "0.1em 0.5em 0",
      paddingLeft: "2px",
      paddingRight: "20px",
    };

    const longStyle = {
      marginTop: "0.5em",
      paddingRight: "80px"
    }

    const extraLongStyle = {
      paddingRight: "70px"
    }

    return (
      <LandingPage className="landingPage2" bgImg={this.props.bgImg} >

        <div>
          <p style={ {...h2Style, ...longStyle} }>YOU ARE</p>
          <p style={ {...h2Style, ...extraLongStyle} }>ABOUT TO</p><br/>
          <p style={h2Style}>ENTER AN</p><br/>
          <p style={h2Style}>ENTIRELY</p><br/>
          <p style={h2Style}>NEW WORLD...</p><br/>
        </div>

      </LandingPage>
    );
  }
}

export default LandingPage2;



// WEBPACK FOOTER //
// ./src/components/LandingPage2/index.js